export default function addVisibilityObserver(el,
  callbacks, options = { rootMargin: 0, threshold: 0 }) {
  const state = {
    isVisible: false,
    wasVisible: false,
  };

  const callback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        state.isVisible = true;
        el.classList.add('-intersecting');
        el.classList.add('-was-in-viewport');
        callbacks.intersect?.(true);

        if (state.wasVisible === false) {
          callbacks?.onFirstEnter?.();
          state.wasVisible = true;
        }
      } else {
        el.classList.remove('-intersecting');
        callbacks.intersect?.(false);
      }
    });
  };

  const observer = new IntersectionObserver(callback, options);
  observer.observe(el);
}
